import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrackIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "background",
			d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
			fill: "url(#paint0_linear_579_33199)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_579_33199)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_579_33199",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: -23,
				y: 5,
				width: 55,
				height: 55,
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 4.5,
					cy: 32.5,
					r: 27.5,
					fill: "#D9D9D9"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_579_33199)",
				children: /* @__PURE__ */ _jsx("path", {
					opacity: .3,
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-4.70756 -0.652803H25.3157C29.9201 -0.652803 33.6526 3.07972 33.6526 7.68402V37.7073C33.6526 40.6069 32.1723 43.1608 29.9262 44.6544C29.652 39.6977 28.5421 34.8168 26.6378 30.2196C24.4225 24.8711 21.1753 20.0114 17.0818 15.9179C12.9883 11.8244 8.12855 8.57724 2.78012 6.36185C-1.81704 4.45764 -6.69788 3.34775 -11.6546 3.07352C-10.1609 0.827461 -7.60712 -0.652803 -4.70756 -0.652803ZM-13.0433 7.55035C-13.044 7.59483 -13.0444 7.63939 -13.0444 7.68403V16.9637C-9.44248 17.0887 -5.88921 17.8588 -2.55426 19.2402C1.10297 20.755 4.42602 22.9754 7.22514 25.7745C10.0243 28.5737 12.2447 31.8967 13.7595 35.5539C15.1409 38.8889 15.911 42.4422 16.036 46.0442H25.3157L25.3702 46.044L25.4493 46.0431C25.3213 41.2056 24.3065 36.4295 22.4524 31.9532C20.4647 27.1545 17.5512 22.7942 13.8784 19.1213C10.2055 15.4485 5.84524 12.535 1.04645 10.5473C-3.42983 8.69317 -8.20587 7.67838 -13.0433 7.55035ZM-13.0444 30.9187V21.4972C-10.0376 21.6201 -7.07317 22.2719 -4.28793 23.4256C-1.18034 24.7128 1.64329 26.5995 4.02174 28.978C6.40018 31.3564 8.28686 34.18 9.57407 37.2876C10.7278 40.0729 11.3796 43.0374 11.5025 46.0442H2.08095C1.9665 44.2738 1.56193 42.5317 0.881206 40.8883C0.0668507 38.9223 -1.12677 37.1359 -2.6315 35.6312C-4.13623 34.1265 -5.92261 32.9328 -7.88863 32.1185C-9.53202 31.4378 -11.274 31.0332 -13.0444 30.9187ZM-13.0444 35.4622V37.7073C-13.0444 42.3116 -9.31186 46.0442 -4.70756 46.0442H-2.4625C-2.56811 44.8694 -2.85134 43.7154 -3.30425 42.622C-3.89093 41.2056 -4.75085 39.9186 -5.83491 38.8346C-6.91896 37.7505 -8.20592 36.8906 -9.6223 36.3039C-10.7157 35.851 -11.8697 35.5678 -13.0444 35.4622ZM-17.5747 7.68403C-17.5747 0.577706 -11.8139 -5.18311 -4.70756 -5.18311H25.3157C32.4221 -5.18311 38.1829 0.577705 38.1829 7.68402V37.7073C38.1829 44.8137 32.4221 50.5745 25.3157 50.5745H-4.70756C-11.8139 50.5745 -17.5747 44.8137 -17.5747 37.7073V7.68403Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_579_33199",
			x1: 20,
			y1: 0,
			x2: 20,
			y2: 40,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#88DDCE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#38C7AD"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_579_33199",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 35,
				fill: "white",
				transform: "translate(0 5)"
			})
		})] })
	]
});
export default SvgTrackIcon;
